import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './common-components/login/login.component';
import { NotFoundComponent } from './common-components/not-found/not-found.component';
import { ForgotPasswordComponent } from './common-components/forgot-password/forgot-password.component';
import { ForgotPasswordNewComponent } from './common-components/forgot-password-new/forgot-password-new.component';
import { ChangePasswordComponent } from './common-components/change-password/change-password.component';
import { AuthGuard } from './auth.guard';
import { TwoFactorAuthComponent } from './common-components/two-factor-auth/two-factor-auth.component';
import { ResetPasswordComponent } from './common-components/reset-password/reset-password.component';
import { WelcomePageComponent } from './common-components/welcome-page/welcome-page.component';
import { MultipleTabComponent } from './common-components/multiple-tab/multiple-tab.component';
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'two-factor-auth', component: TwoFactorAuthComponent },
  { path: 'welcome-page', component: WelcomePageComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'forgot-password-new/:securityCode', component: ForgotPasswordNewComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'multiple-tab', component: MultipleTabComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard], data: { route: ['change-password'] } },
  {
    path: 'supervisor',
    loadChildren: () => import('./supervisor_modules/supervisor.module').then(m => m.SupervisorModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./agent_modules/agent.module').then(m => m.AgentModule)
  },
  {
    path: 'clientsupervisor',
    loadChildren: () => import('./client_supervisor_modules/client-supervisor.module').then(m => m.ClientSupervisorModule)
  },
  {
    path: 'clientuser',
    loadChildren: () => import('./client_user_modules/client-user.module').then(m => m.ClientUserModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin_modules/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'administrator',
    loadChildren: () => import('./administrator_modules/administrator.module').then(m => m.AdministratorModule)
  },
  {
    path: 'director',
    loadChildren: () => import('./director_modules/director.module').then(m => m.DirectorModule)
  },
  {
    path: 'manager',
    loadChildren: () => import('./manager_modules/manager.module').then(m => m.ManagerModule)
  },
  {
    path: 'controller',
    loadChildren: () => import('./controller_modules/controller.module').then(m => m.ControllerModule)
  },
  {
    path: 'qc',
    loadChildren: () => import('./qc_modules/qc.module').then(m => m.QcModule)
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
    HttpModule,
    RouterModule.forRoot(routes),
    FormsModule,ReactiveFormsModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
